
import React, { Fragment as F, useContext, useEffect, useLayoutEffect, useState
} from 'react'
import {
  Link,
  useLocation,
  useParams,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  appRouter,
  logg,
  useApiRouter,
} from '$shared'

import {
  BanksCtx,
  BanksIndexTable,
} from './'

import {
  AppCtx,
} from '$src/App'
import {
  SchedulesCtx,
} from '$src/components/schedules'

/**
 * ResultsTable
 * @TODO: remove this component, merge it into BanksIndexTable
**/
const ResultsTable = (props) => {
  // logg(props, 'ResultsTable')

  /* ctx */

  const apiRouter = useApiRouter()
  const { search } = useLocation()

  const {
    actionName, setActionName,
    loading, setLoading,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in ResultsTable')

  const {
    banksSearchModalOpen, setBanksSearchModalOpen,
    results, setResults, clearResults,
    resultsTitle, setResultsTitle,
  } = useContext(BanksCtx)

  const {
    query_ids,
  } = useParams()
  // logg(useParams(), 'params in ResultsTable')

  const {
    oneResultTitle, setOneResultTitle, defaultOneResultTitle,
  } = useContext(SchedulesCtx)

  /* state */

  /* effects */

  useEffect(() => {
    setActionName(appRouter.banksResultsRoute)
    if (!query_ids && !results.length) {
      if (new URLSearchParams(search).get('op') === 'banks-quick-search') {
        setBanksSearchModalOpen(true)
      }
    }
  }, [] )

  /*
   * queries view
  **/
  useEffect(() => {
    if (query_ids) {
      setLoading(true)
      fetch(apiRouter.queriesRunPath(query_ids)).then(r => {
        if (!r.ok) {
          throw new Error("t99 - We're sorry, something went wrong. Please try again later.")
        }
        return r.json()
      }).then(rows => {
        // logg(rows, 'got queriesView in ResultsTable')

        setResults(rows)
        if (rows.length) {
          setResultsTitle(<F>
            <span onClick={() => setOneResultTitle(null) } >
              <u><Link to={appRouter.banksResultsRoute} >Search results ({rows.length})</Link></u>
            </span>
            {/* { appRouter.banksResultsRoute === actionName && <Link to="/"><div className='clear-results-btn'
                onClick={clearResults}>&nbsp;&times;&nbsp;</div></Link> } */}
          </F>)
        } else {
          setOneResultTitle('No institutions meet this criteria')
        }
      }).catch((err) => {
        logg(err, 'err in ResultsTable')
        toast(err.toString())
      }).finally(() => {
        setLoading(false)
      })
    }
  }, [ query_ids, actionName ])

  return <div className='ResultsTable' data-testid="ResultsTable" >
    { results.length && <BanksIndexTable banks={results} /> || null }
  </div>
}
export default ResultsTable
